import * as React from "react";
import { Button } from "@sgbs-ui/core";

interface SlotInfoProps {
  isExpanded: boolean;
  onToggleExpand: () => void;
}

export const SlotInfo: React.FC<React.PropsWithChildren<SlotInfoProps>> = ({
  isExpanded,
  onToggleExpand,
  children,
}) => (
  <>
    <div className="d-flex align-items-center gap-1 w-100">
      <span className="icon icon-sm icon-outlined text-secondary">info</span>
      <div className={`d-inline-block w-100 ${isExpanded ? "" : " text-truncate"}`}>
        <span className="fs-14 text-secondary">{children}</span>
      </div>
    </div>
    <Button btnType="link" className="align-self-center" onClick={onToggleExpand}>
      {isExpanded ? "See less" : "See more"}
    </Button>
  </>
);
